"use client";
import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

import SignupSlider from "../../Components/Signupslider/index";
import Signup from "./Signup";
import { toast } from "react-toastify";
import { handleApiCall } from "../../apis";
import { endpoint } from "../../utils/endpoints";

const toFileArray = (value) => {
  if (!value) return [];
  const list = Array.isArray(value) ? value : [value];
  return list.filter((f) => f instanceof File);
};

const Signupvendor = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const initialData = location.state || {}; // Getting data from previous page
  console.log(initialData, "initialData");
  const { details, selectedOptions } = location.state || {};
  const [loading, setLoading] = useState(false);
  // State for form data
  const [formData, setFormData] = useState({
    ...initialData, // Spread previous data
    gst_number: initialData.gst_number || "",
    pan_number: initialData.pan_number || "",
    gstCertificate: initialData.gstCertificate || null,
    businessLicense: initialData.businessLicense || null,
    panCard: initialData.panCard || null,
    address_proof: initialData.address_proof || null,
  });

  // Single file upload using common upload API
  const uploadSingleFile = async (file) => {
    try {
      const data = new FormData();
      data.append("file", file);
      const res = await handleApiCall("post", endpoint.uploadSingleFile, data);
      console.log("file upload res", res);
      if (res?.data?.code === 200) {
        return res?.data?.data?.filename;
      }
      toast.error(res?.data?.message || "Failed to upload file");
      return null;
    } catch (err) {
      console.error("Error uploading file:", err);
      toast.error("Something went wrong while uploading the file");
      return null;
    }
  };

  // Handle file upload
  const handleFileChange = (e, field) => {
    setFormData({
      ...formData,
      [field]: e.target.files[0], // Store file object
    });
  };

  // Handle input field changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let processedValue = value;

    // For beneficiary name, only allow letters and spaces
    if (name === "name") {
      const lettersOnly = value.replace(/[^a-zA-Z\s]/g, "");
      processedValue = lettersOnly;
    }

    setFormData((prev) => {
      const next = { ...prev, [name]: processedValue };
      if (name === "gst_number" && !String(processedValue).trim()) {
        next.gstCertificate = null;
      }
      return next;
    });
  };
  useEffect(() => {
    if (location?.state?.accountNumber) {
      setFormData((prev) => ({
        ...prev,
        ...initialData,
        gst_number: initialData.gst_number || prev.gst_number || "",
        pan_number: initialData.pan_number || prev.pan_number || "",
      }));
    }

    // Pre-fill business_license / address_proof from step 1 businessDetails (arrays or single File).
    const businessDetails = initialData.Signupdata?.businessDetails || [];
    if (businessDetails.length > 0) {
      const businessWithFiles =
        businessDetails.find((b) => b?.businessLicense || b?.portfolio) ||
        businessDetails[0];

      setFormData((prev) => ({
        ...prev,
        businessLicense:
          prev.businessLicense || businessWithFiles.businessLicense || null,
        address_proof:
          prev.address_proof || businessWithFiles.portfolio || null,
      }));
    }
  }, [location?.state]);

  // Validate form before submission
  const validateForm = () => {
    const gstTrimmed = formData.gst_number?.trim() || "";
    if (gstTrimmed && !formData.gstCertificate) {
      toast.error("Please upload GST certificate when GST number is provided");
      return false;
    }
    if (!formData.pan_number?.trim()) {
      toast.error("Please enter PAN number");
      return false;
    }
    if (!formData.panCard) {
      toast.error("Please upload PAN Card");
      return false;
    }
    // Validate bank details if provided
    if (formData.selectedOptions && formData.selectedOptions.length > 0) {
      if (!formData.name?.trim()) {
        toast.error("Please enter beneficiary name");
        return false;
      } else if (!/^[a-zA-Z\s]+$/.test(formData.name.trim())) {
        toast.error("Beneficiary name should contain only letters");
        return false;
      }
      if (!formData.accountNumber?.trim()) {
        toast.error("Please enter account number");
        return false;
      }
      if (!formData.reaccountNumber?.trim()) {
        toast.error("Please re-enter account number");
        return false;
      }
      if (formData.accountNumber !== formData.reaccountNumber) {
        toast.error("Account numbers do not match");
        return false;
      }
      if (!formData.IFSCcode?.trim()) {
        toast.error("Please enter IFSC code");
        return false;
      }
    }
    return true;
  };

  // Function to call API with step 2
  const handleNext = async () => {
    if (!validateForm()) {
      return;
    }

    // Get email from Signupdata
    const signupData = initialData.Signupdata || {};
    const email = signupData?.email || "";

    if (!email) {
      toast.error("Email is missing. Please go back and complete the form.");
      return;
    }

    try {
      setLoading(true);

      // Upload GST and PAN via single-file API; business_license / address_proof stay as raw files (multipart).
      const gstFile = formData.gstCertificate;
      const panFile = formData.panCard;
      const businessLicenseFiles = toFileArray(formData.businessLicense);
      const addressProofFiles = toFileArray(formData.address_proof);
      const [gstFilename, panFilename] = await Promise.all([
        gstFile ? uploadSingleFile(gstFile) : Promise.resolve(null),
        panFile ? uploadSingleFile(panFile) : Promise.resolve(null),
      ]);

      // If upload failed, stop further submission
      if (gstFile && !gstFilename) {
        setLoading(false);
        return;
      }
      if (panFile && !panFilename) {
        setLoading(false);
        return;
      }

      // Create FormData for step 2 payload
      const formDataToSend = new FormData();

      // Add step
      formDataToSend.append("step", "2");

      // Add string fields
      formDataToSend.append("email", email);
      formDataToSend.append("gst_number", formData.gst_number || "");
      formDataToSend.append("pan_number", formData.pan_number || "");

      // Add bank details if available
      if (formData.selectedOptions && formData.selectedOptions.length > 0) {
        formDataToSend.append("bank_name", formData.selectedOptions[0] || "");
        formDataToSend.append(
          "bank_type",
          formData.selectedOptions2?.[0] || ""
        );
        formDataToSend.append("beneficiary_name", formData.name || "");
        formDataToSend.append("account_number", formData.accountNumber || "");
        formDataToSend.append(
          "re_account_number",
          formData.reaccountNumber || ""
        );
        formDataToSend.append("ifsc_code", formData.IFSCcode || "");
      } else {
        formDataToSend.append("bank_name", "");
        formDataToSend.append("bank_type", "");
        formDataToSend.append("beneficiary_name", "");
        formDataToSend.append("account_number", "");
        formDataToSend.append("re_account_number", "");
        formDataToSend.append("ifsc_code", "");
      }

      // Add uploaded file names instead of raw files
      if (gstFilename) {
        formDataToSend.append("gst_certificate", gstFilename);
      }

      if (panFilename) {
        formDataToSend.append("pancard", panFilename);
      }

      businessLicenseFiles.forEach((file) =>
        formDataToSend.append("business_license", file)
      );
      addressProofFiles.forEach((file) =>
        formDataToSend.append("address_proof", file)
      );

      console.log("FormData being sent:", {
        step: "2",
        email,
        gst_number: formData.gst_number,
        pan_number: formData.pan_number,
        bank_name: formData.selectedOptions?.[0] || "",
        bank_type: formData.selectedOptions2?.[0] || "",
        beneficiary_name: formData.name || "",
        account_number: formData.accountNumber || "",
        re_account_number: formData.reaccountNumber || "",
        ifsc_code: formData.IFSCcode || "",
      });

      const response = await handleApiCall(
        "post",
        `${endpoint.registerVendor}`,
        formDataToSend
      );

      console.log(response, "response step 2");

      if (response?.data?.code === 200 || response?.status === 200) {
        toast.success("Step 2 completed successfully!");
        // Navigate to next step with the data
        navigate("/finish-signup", {
          state: { ...formData, ...location.state },
        });
      } else {
        toast.error(
          response?.response?.data?.errorMessage ||
            response?.data?.message ||
            "Submission failed"
        );
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error(
        error?.response?.data?.errorMessage ||
          "An error occurred during submission"
      );
    } finally {
      setLoading(false);
    }
  };

  // Function to get background color based on file selection
  const getBackgroundColor = (file) => {
    return file ? "bg-buttonbg" : "bg-white";
  };

  const gstNumberFilled = Boolean(formData.gst_number?.trim());

  return (
    <>
      <div className="w-full md:flex block">
        <div className="md:w-6/12 w-full">
          <div className="flex justify-center h-screen">
            <div className="block md:w-80 w-10/12 mt-[30px]">
              <img src="images/black-logo.svg" alt="Logo" className="mx-auto" />
              <h1 className="text-2xl text-black text-center font-BonaNovaRegular py-2">
                Sign up as vendor
              </h1>
              <img
                src="/images/progress-two.png"
                alt="Progress"
                className="w-40 mx-auto py-2"
              />

              <form className="space-y-3 mt-4">
                {/* GST Number Input (optional) */}
                <div>
                  <div className="text-[13px] font-Montserratmedium text-[#2B2B2B] opacity-50 mb-[5px]">
                    GST Number{" "}
                    <span className="text-[#A3A3A3] font-Montserratmedium">(optional)</span>
                  </div>
                  <input
                    type="text"
                    name="gst_number"
                    placeholder="GST Number"
                    value={formData.gst_number || ""}
                    onChange={handleInputChange}
                    className="mt-1 w-full px-3 py-2 border !border-inputfieldborder bg-white outline-none text-13 font-Montserratmedium text-forgetpassword min-h-[42px]"
                  />
                </div>

                {/* PAN Number Input */}
                <div>
                  <input
                    type="text"
                    name="pan_number"
                    placeholder="PAN Number"
                    required
                    value={formData.pan_number || ""}
                    onChange={handleInputChange}
                    className="mt-1 w-full px-3 py-2 border !border-inputfieldborder bg-white outline-none text-13 font-Montserratmedium text-forgetpassword min-h-[42px]"
                  />
                </div>

                {/* GST Certificate Upload — enabled only when GST number is entered */}
                <div
                  className={`border !border-dashed !border-inputfieldborder py-3 text-center relative transition-opacity ${
                    gstNumberFilled
                      ? `cursor-pointer ${getBackgroundColor(formData.gstCertificate)}`
                      : "cursor-not-allowed opacity-45 bg-[#F5F5F5]"
                  }`}
                  aria-disabled={!gstNumberFilled}
                >
                  <input
                    type="file"
                    disabled={!gstNumberFilled}
                    className={`absolute inset-0 w-full h-full opacity-0 ${
                      gstNumberFilled ? "cursor-pointer" : "cursor-not-allowed"
                    }`}
                    onChange={(e) => handleFileChange(e, "gstCertificate")}
                    accept="image/*, application/pdf"
                  />
                  <div className="flex mx-auto w-7/12 justify-center items-center gap-2 pointer-events-none">
                    <img
                      src="/images/upload.png"
                      alt="Upload Icon"
                      className="h-3 w-3"
                    />
                    <p className="text-[13px] font-Montserratmedium text-[#2B2B2B]">
                      Upload GST Certificate
                    </p>
                  </div>
                  {!gstNumberFilled && (
                    <p className="text-[11px] font-Montserratmedium text-[#A3A3A3] mt-1 px-2 pointer-events-none">
                      Enter GST number above to upload certificate
                    </p>
                  )}
                </div>

                {/* PAN Upload */}
                <div
                  className={`border !border-dashed !border-inputfieldborder py-3 cursor-pointer text-center relative ${getBackgroundColor(
                    formData.panCard
                  )}`}
                >
                  <input
                    type="file"
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                    onChange={(e) => handleFileChange(e, "panCard")}
                    accept="image/*, application/pdf"
                  />
                  <div className="flex mx-auto w-7/12 justify-center items-center gap-2">
                    <img
                      src="/images/upload.png"
                      alt="Upload Icon"
                      className="h-3 w-3"
                    />
                    <p className="text-[13px] font-Montserratmedium text-[#2B2B2B]">
                      Upload PAN
                    </p>
                  </div>
                </div>

                {/* Add Bank Account */}

                <button
                  type="button"
                  onClick={() =>
                    navigate("/addbank", {
                      state: location?.state?.accountNumber
                        ? location.state
                        : formData,
                    })
                  }
                  className={`px-8 py-2 bg-${
                    location?.state?.accountNumber ? "buttonbg" : "white"
                  } border !border-inputfieldborder text-13 text-bankaccountcont focus:outline-none font-Montserratmedium w-full`}
                >
                  + Add bank account
                </button>

                {/* Next Button */}
                <button
                  type="button"
                  onClick={handleNext}
                  disabled={loading}
                  className="mt-4 px-8 py-2 bg-buttonbg text-13 text-white focus:outline-none font-BonaNovaRegular w-full disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? "Processing..." : "Next"}
                </button>
              </form>

              <div className="mt-4 text-right text-xs font-Montserratbold text-black text-center">
                <Link to="/register">Back</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="md:w-6/12 w-full hidden md:block">
          <SignupSlider />
        </div>
      </div>
</>
  );
};

export default Signupvendor;
